import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function useSections() {
  const [sections, setSections] = useState([]);
  useEffect(() => {
    api
      .get("/sections")
      .then((res) => setSections(res.data.filter((s) => s.in_menu)))
      .catch(() => {});
  }, []);
  return sections;
}
